(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fiid-product-swatch-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fiidSwatchPrefetchBound) return;
    window.__fiidSwatchPrefetchBound = true;
    const prefetched = new Set();
    document.addEventListener(
      'pointerenter',
      (event) => {
        const a = event.target.closest('a.fiid-product-swatch-nav__swatch[href]');
        if (!a) return;
        if (!a.closest('.fiid-product-swatch-nav')) return;
        const href = a.getAttribute('href');
        if (!href || href.startsWith('#')) return;
        if (prefetched.has(href)) return;
        prefetched.add(href);
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = href;
        link.as = 'document';
        document.head.appendChild(link);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
